import React, {useEffect} from 'react';
import './index.scss';

const Layout = (props: any) => {
  const [active, setActive] = React.useState('');

  useEffect(() => {
    const handleHashChange = () => {
      setActive(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    setActive(window.location.hash);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const onClick = (hash: any) => {
    window.location.hash = hash;
  }

  return (
    <div className="layout-container">
      <div className="header">
        <div className="logo-wrapper">
          <div className="logo"></div>
          <span className="title">GOGO Credi</span>
        </div>
        <div className="nav">
          <span
            className={!active || active === '#/' ? 'active' : ''}
            onClick={() => onClick('')}
          >INICIO</span>
          <span
            className={active === '#/ayuda' ? 'active' : ''}
            onClick={() => onClick('#/ayuda')}
          >AYUDA</span>
        </div>
      </div>
      {props.children}
    </div>
  )
}

export default Layout;
